var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-draggable-resizable",
    {
      staticClass: "network-layers-container",
      attrs: {
        w: _vm.width,
        h: _vm.height,
        x: _vm.posX,
        y: _vm.posY,
        active: true,
        parent: true,
        resizable: false,
        "drag-handle": ".drag"
      },
      on: { dragstop: _vm.onDragStop }
    },
    [
      _c(
        "div",
        { staticClass: "layersCable toolsWindow drag scroll-fire-fox" },
        [
          _c(
            "v-layout",
            {
              staticClass: "home-floating-window-header layersCableTitle",
              attrs: { row: "", "justify-space-between": "" }
            },
            [
              _vm._v("\n      " + _vm._s(_vm.$t("NetworkLayers")) + "\n      "),
              _c("window-header-button", {
                staticStyle: { "margin-left": "20px" },
                attrs: { mode: "dark" },
                on: { onClick: _vm.close }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-treeview", {
            staticStyle: { "text-align": "left", "font-size": "12px" },
            attrs: {
              value: _vm.selected,
              items: _vm.menu,
              "item-key": "key",
              "item-children": "submenu",
              "item-text": "name",
              selectable: "",
              id: "layers-network-tree",
              "return-object": ""
            },
            on: { input: _vm.setActiveNetworkFilters },
            scopedSlots: _vm._u([
              {
                key: "prepend",
                fn: function(ref) {
                  var item = ref.item
                  var active = ref.active
                  return [
                    _c(item.icon, {
                      tag: "component",
                      staticStyle: {
                        "margin-right": "3px",
                        "margin-top": "6px"
                      },
                      attrs: { width: "15px" }
                    })
                  ]
                }
              },
              {
                key: "label",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "10px",
                          "padding-left": "3px"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.name) + "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d6b7df8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d6b7df8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/SideBar/SidebarWindows/Layers/NetworkLayers.vue
// module id = null
// module chunks = 